import React from 'react';
import { gql } from '@soundxyz/gql-string';
import type { FragmentType } from '@graphql/reactQuery';
import { getFragment, ReleaseLikedListFragmentDoc } from '@graphql/reactQuery';
import { ACTION_TYPE, SingleReleaseList } from './SingleRelease';

/*#__PURE__*/ gql(/* GraphQL */ `
  fragment ReleaseLikedList on ReleaseLiked {
    id
    date
    release {
      id
      ...ReleasePill
    }
    user {
      id
      ...MinimalUser
    }
  }
`);

export const ReleaseLikedList = ({
  activityFrag,
}: {
  activityFrag: FragmentType<ReleaseLikedListFragmentDoc>;
}) => {
  const { user, release, date } = getFragment(ReleaseLikedListFragmentDoc, activityFrag);

  return (
    <SingleReleaseList
      userFrag={user}
      releaseFrag={release}
      isoDateString={date}
      action={ACTION_TYPE.RELEASE_LIKED}
    />
  );
};
